module.exports = __webpack_public_path__ + "static/img/logo_white.c96a90b2.svg";